module.exports = __webpack_public_path__ + "static/media/trendyol.b621a72f.png";